import React from "react";
import { Button } from "@purpur/button";
import type { BaseProps } from "@purpur/common-types";
import { Icon } from "@purpur/icon";
import { playFilled } from "@purpur/icon/assets/play-filled";
import { tvPause } from "@purpur/icon/assets/tv-pause";

import styles from "./hero-banner.module.scss";

const rootClassName = "purpur-hero-banner";

type WithVideo = {
  /** Video pause/play button callback (your implementation should handle the state) */
  togglePausePlay: () => void;
  /** Video pause/play button status (your implementation should handle the state) */
  isPlaying?: boolean;
  /** Aria label for the pause/play button, when the video is playing */
  videoPauseAriaLabel: string;
  /** Aria label for the pause/play button, when the video is not playing */
  videoPlayAriaLabel: string;
};

type WithoutVideo = {
  togglePausePlay?: never;
  isPlaying?: never;
  videoPauseAriaLabel?: never;
  videoPlayAriaLabel?: never;
};

export type HeroBannerMediaProps = BaseProps & (WithVideo | WithoutVideo);

export const HeroBannerMedia = ({
  children,
  isPlaying,
  togglePausePlay,
  videoPauseAriaLabel,
  videoPlayAriaLabel,
  className,
  ...props
}: HeroBannerMediaProps) =>
  children && (
    <div className={className} {...props}>
      {children}
      {!!togglePausePlay && (
        <Button
          variant="primary"
          negative
          iconOnly
          onClick={() => {
            togglePausePlay();
          }}
          className={styles[`${rootClassName}__video-button`]}
          aria-label={isPlaying ? videoPauseAriaLabel : videoPlayAriaLabel}
        >
          <Icon size="xs" svg={isPlaying ? tvPause : playFilled} />
        </Button>
      )}
    </div>
  );
